import { useState } from "preact/hooks"
import Header from "./Header"
import LeaderboardInput from "./Leaderboard-input"

export default function({submit = (data, initialData) => {}, initialData = {}, update = false}) {

    const [initial, setInitial] = useState(initialData)
    const [allowsMultiple, setAllowsMultiple] = useState(initial.allowsMultiple || false)

    this.addData = (data) =>  {
        setInitial(data)
        setAllowsMultiple(data.allowsMultiple || false)
    }

    const createEventSubmit = ev => {
        ev.preventDefault();
        const data = Object.fromEntries(new FormData(ev.target).entries())

        submit({
            ...data, 
            timeout: data.timeout ? data.timeout * 1000 : undefined,
            allowsMultiple: data.allowsMultiple == "on" ? true : false,
            value: parseInt(data.value),
            "isActive": true,
            "isHidden": false
        }, initial)
    }

    const multipleSet = ev => {
        setInitial({ ...initial, allowsMultiple: ev.target.checked})
        setAllowsMultiple(ev.target.checked)
    }

    return <form id = "createRule" class = "tk-form" onSubmit = { createEventSubmit }>
        <Header name = "Descriptive Config"/>
        <LeaderboardInput label = "name" name = "name" required = {true} initial = {initial.name || ''}/>
        <LeaderboardInput label = "Description" name = "description" initial = {initial.description  || ''}/>
        <LeaderboardInput label = "Points" name = "value" type = "number" min = "0" initial = "0" required = {true} min = "1" initial = {initial.value || ''}/>

        <Header name = "Multiple Config"/>
        <LeaderboardInput label = "Allows Multiple" name = "allowsMultiple" type = "checkbox" change = {multipleSet} initial = {initial.allowsMultiple || allowsMultiple || false}/>
        { allowsMultiple ? <>
            <LeaderboardInput label = "Limit" name = "limit" type = "number" min = "0" initial = {initial.limit || ''}/>
            <p>*if zero, it's unlimited</p>
            <LeaderboardInput label = "Timeout (seconds)" name = "timeout" type = "number" min = "0" initial = {initial.timeout || ''}/>
            <p>*if zero, there's no timeout</p>
        </> : null}

        <Header name = "ID Set"/>
        <LeaderboardInput label = "Event ID" name = "eventId" required = {true} initial = {initial.eventId || ''}/>

        <input class = "tk-btn" type = "submit" value = { update ? "Update" : "Create"}/>
    </form>
}
